// @flow

const getConfiguration = (props: any): any => {
    return {
        enableHeader: false,
        enableToolbar: false,
    }
}
export default getConfiguration;